import { Provider } from '@angular/core';

// Injection token for the Http Interceptors multi-provider
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';

/** Provider for the Noop Interceptor. */
export const authenticationInterceptor: Provider = { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }